export default "__VITE_PUBLIC_ASSET__0c470b25__"